var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-content-layout',{staticClass:"tracker-list",attrs:{"title":"Trackers"}},[_c('button-view',{attrs:{"slot":"tools","label":"Opret"},on:{"click":_vm.createButtonClick},slot:"tools"}),_c('new-table-view',{ref:"table",attrs:{"columns":[
		{
			label: 'Label',
			name: 'label'
		},
		{
			label: 'Check-in',
			name: 'checkin',
			translation: {
				true: 'Ja',
				false: 'Nej'
			}
		},
		{
			label: 'Radius',
			name: 'dist',
			suffix: ' m',
			filter: 'integer',
			align: 'right'
		},
		{
			label: 'Hysterese',
			name: 'hyst',
			suffix: ' m',
			filter: 'integer',
			align: 'right'
		},
		{
			label: '',
			name: 'delete',
			align: 'right',
			template: {
				name: 'button',
				label: 'Slet'
			}
		}
	],"items":_vm.items},on:{"itemClick":_vm.itemClick,"delete":_vm.itemDelete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }